<template>
  <div class="guestPassConfirm full-height  linear-main3">
    <ld-header
      @click-left="$router.push({path:'/allOrder?findType=1'})"
      transparent
      white
    >
      <div class="font12">
        订单号：{{ detail.orderNo }} {{ detail.tripType==1?'公':'私' }}
      </div>
    </ld-header>
    <div class="wrapper">
      <mescroll-vue
        ref="mescroll"
        :down="{use:false}"
      >
        <div class="mainbox">
          <div class="box">
            <div class="white list">
              <div class="font24 font-lg box">
                {{ detail.orderStatus|orderStatus }}<span v-show="detail.orderStatus!=5"> | {{ detail.payStatus==0?'待支付':'已支付' }} </span> <span v-show="detail.usageStatus"> | {{ detail.usageStatus|usageStatus }}</span>
              </div>
              <van-row
                v-show="detail.isAutoCancle"
                type="flex"
                align="center"
              >
                <van-col span="7">
                  支付时限剩余：
                </van-col>
                <van-col span="10">
                  <van-count-down
                    ref="countDown"
                    style="color:red;font-size:16px"
                    :time="times"
                    @finish="getDetail"
                    format=" HH 时 mm 分 ss 秒"
                  />
                </van-col>
              </van-row>
              <div>预订人：{{ detail.bookerName }}</div>
              <div>预订时间：{{ detail.bookDate }}</div>
              <div v-show="detail.payStatus==1">
                <div>支付时间：{{ detail.payDate }} {{ detail.payMothedName }}</div>
              </div>
            </div>
          </div>

          <div class="box">
            <van-cell>
              <van-row>
                <van-col span="12">
                  <span class="font-bold">要客通</span>
                </van-col>
                <van-col
                  span="12"
                  class="text-right main-color"
                  @click="$dialog.alert({
                    title:'服务介绍',
                    messageAlign:'left',
                    message:detail.productDesc.split('\n').join('</br>')
                  })"
                >
                  服务介绍
                </van-col>
              </van-row>
            </van-cell>
            <van-field
              label="服务机场"
              input-align="right"
              :value="`${detail.cityName} ${detail.airportName}`"
              readonly
            />
            <van-field
              input-align="right"
              label="服务日期"
              v-model="detail.serverTime"
              readonly
            />
            <van-field
              label="服务类型"
              input-align="right"
              readonly
            >
              <template #extra>
                <div class="font-bold">
                  {{ detail.setOutModel|setOutModel }} {{ detail.serverType ==1?'接机服务':'送机服务' }} {{ detail.productName }}
                </div>
              </template>
            </van-field>

            <van-field
              label="航班号"
              input-align="right"
              v-model="detail.flightNo"
              readonly
            />
            <van-field
              label="服务人数"
              input-align="right"
              readonly
            >
              <template #extra>
                {{ detail.personTime }} 人
              </template>
            </van-field>
            <van-field
              label="备注"
              type="textarea"
              autosize
              input-align="right"
              v-model="detail.serverRemark"
              readonly
            />
          </div>
          <div
            class="box"
            v-if="detail.orderStatus==3||detail.orderStatus==4"
          >
            <van-field
              label="用户提示"
              readonly
              autosize
              type="textarea"
            >
              <template
                #input
                class="font12"
              >
                {{ detail.userTips }}
              </template>
            </van-field>
          </div>
          <!--  -->
          <travel-info
            ref="travelinfo"
            :travel-data="detail"
            :details="true"
          />
        </div>
      </mescroll-vue>
    </div>
    <!-- 底部导航 -->
    <ld-tabbar
      ref="tabbar"
      :price-list="priceList"
    >
      <van-row
        type="flex"
        align="center"
        gutter="16"
        justify="space-between"
        class="bg-white full-width shadow list"
      >
        <van-col span="8">
          <span class="font12 money-color">&yen;</span><span
            class="font22 money-color"
          >{{ detail.totalAmount }}</span>
          <span class="font10 gray">{{ $t('E017','共') }}{{ detail.obtAirportServerOrderPsgBeanList.length }}人</span>
        </van-col>
        <!-- <van-col span="8">
          <div
            class="font12 text-left"
            @click="toggle('tabbar')"
          >
            <span>{{ $t('E006','明细') }}</span>
            <van-icon
              name="arrow-up"
              class="vertical-middle"
              size="14"
            />
          </div>
        </van-col> -->
        <van-col
          span="8"
          v-show="detail.orderStatus<3&&detail.payStatus==0"
        >
          <ld-button
            :loading="false"
            size="md"
            defaults
            @click.native="cancel"
          >
            取消
          </ld-button>
        </van-col>
        <van-col
          span="8"
          v-show="detail.payStatus==0&&detail.orderStatus<3"
        >
          <ld-button
            :loading="false"
            size="md"
            main
            @click.native="pay"
          >
            去支付
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>

    <!--  -->
    <!-- <van-popup
      :lock-scroll="true"
      v-model="showExpiryDate"
      :close-on-popstate="true"
      position="bottom"
    >
      <van-datetime-picker
        v-model="expiryDate"
        type="date"
        @cancel="showExpiryDate != false"
        @confirm="expiryDateSelect"
      />
    </van-popup> -->
  </div>
</template>

<script>
import {Field,Cell,Stepper,Popup,DatetimePicker,CountDown } from 'vant'
import { mapGetters } from 'vuex'
import { formatDate ,getDiffMinutes,getPreStrTime} from 'Utils/dateUtil'
// import tripType from 'Common/tripType'
// import ldEditLinker from 'Components/ldEditLinker'
// import traver from 'Components/tk/traver'
import ldButton from 'Common/ldButton'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import travelInfo from 'Components/travelInfo'

export default {
  name: 'GuestPassConfirm',
  components:{
    [Field.name]: Field,
    [Cell.name]: Cell,
    [Stepper.name]: Stepper,
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [CountDown.name]: CountDown,
    // tripType,
    // ldEditLinker,
    ldTabbar,
    ldButton,
    // traver,
    travelInfo,
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
  },
  data () {
    return {
      pnum:1,
      flightNo:'',
      departDate:'123',
      priceList: [],
      showExpiryDate: false,
      expiryDate: new Date(),
      linker:{},
      detail:{
        obtAirportServerOrderPsgBeanList:[]
      },
      orderId:'',
      times:60*60*1000
    }
  },
  computed: {
    ...mapGetters({
      sysType:'sysType',
      userInfo:'userInfo',
    }),
    // priceList(){
    // 	let adult= {name:'成人',price:'',amount:0,unit:'人'},
    // 		child={name:'儿童',price:'',amount:0,unit:'人'},
    // 		baby={name:'婴儿',price:'',amount:0,unit:'人'},
    // 		arr=[],first={},
    // 		cxr=this.details.orderPsgBeanList
    // 	if(cxr.length>0){
    // 		cxr.forEach((item) =>{
    // 			if(item.psgType==1){
    // 				adult.amount+=1
    // 				adult.price=item.salePrice+item.airportFee+item.tax+item.serviceFee+(this.details.bxPrice?this.details.bxPrice/cxr.length:0)
    // 				first=item
    // 			}else if(item.psgType==2){
    // 				child.amount+=1
    // 				child.price=item.salePrice+item.airportFee+item.tax+item.serviceFee+(this.details.bxPrice?this.details.bxPrice/cxr.length:0)
    // 			}else if(item.psgType==3){
    // 				baby.amount+=1
    // 				baby.price=item.salePrice+item.airportFee+item.tax+item.serviceFee+(this.details.bxPrice?this.details.bxPrice/cxr.length:0)
    // 			}
    // 		})
    // 		if(!first.salePrice){
    // 			first=cxr[0]
    // 		}
    // 		adult.show=adult.amount>0
    // 		child.show=child.amount>0
    // 		baby.show=baby.amount>0
    // 		arr=[
    // 			adult,child,baby,
    // 			{name:'机票',price:first.salePrice,amount:cxr.length,unit:'/人'},
    // 			{name:'机建',price:first.airportFee,amount:cxr.length,unit:'/人'},
    // 			{name:'燃油税',price:first.tax,amount:cxr.length,unit:'/人'},
    // 			{name:'保险',price:this.details.bxPrice?this.details.bxPrice/cxr.length:0,amount:`/ ${this.checkBxList.length}份`,unit:''},
    // 			{name:'服务费',price:first.serviceFee,amount:cxr.length,unit:'/人'}
    // 		]
    // 	}
    // 	return arr
    // },
  },
  created () {
    this.orderId=this.$route.query.orderId
    this.getDetail()
  },
  methods:{
    getDetail(){
      this.$api['airService/orderDetail']({orderId:this.orderId}).then((res) => {
        let cache=res.data||{}
        this.detail=cache
        if(cache.isAutoCancle ==1){
          this.times=cache.autoCancleTime
        }
        // let layter= getPreStrTime(cache.bookDate,1)
        // let times=getDiffMinutes(formatDate(new Date()).datehms,layter)
        // if(times<=60&&times>1){
        // 	this.times=times*60*1000
        // }
      })
    },
    cancel(){
      this.$dialog.confirm({
        title:'提示',
        message:'确认取消订单？'
      }).then(()=>{
        this.$api['airService/cancel']({orderId:this.orderId,version:this.detail.version,orderFrom:this.sysType}).then((res) => {
          this.$dialog.alert({
            title:'提示',
            message:'订单已取消！'
          }).then(()=>{
            this.getDetail()
          })
        })
      })
    },
    pay(){
      this.$router.push({path:'/pay/payment',query:{orderType:'11031',orderId:this.orderId}})
    },
  },
  watch: {
  },
  filters:{
    orderStatus:function(type){
      var obj={'1':'已预订','2':'已调度','3':'已出票','4':'已完成','5':'已取消'}//1标准
      return obj[type]||''
    },
    usageStatus:function(type){
      var obj={'1':'未使用','2':'已使用','3':'已过期'}
      return obj[type]||''
    },
    setOutModel:function(type){
      var obj={'0':'国内出发、国际出发','1':'国内出发','2':'国内到达','3':'国际出发','4':'国际到达'}
      return obj[type]||''
    }
  }
}
</script>

<style lang="less" scoped>
.mainbox{
    padding: 0 8px 50px;
}
.list{
    padding: 10px;
}
.box{
    padding-bottom: 5px;
}
    .wrapper {
        height: calc(100vh - 96px);
        overflow: hidden;
    }
</style>
